export default {
    paymentMethodTitle:"Moyens de paiement",
    creditCardPaymentMethodExpiryLabel:"Expire le {{date}}",
    defaultPaymentMethodLabel:"Par défaut",
    addPaymentMethodActionLabel:"Ajouter un moyen de paiement",
}
